<template src="./qrcode.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";

  export default {
    components: {},
    props: ["VehicleId", "VehicleClass", "VehicleVRM"],
    data() {
      return {
        ShowLoader: false,
        QRCodeEndpoint: Endpoints.QR.Generate + "?content=",
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Vehicles Check View";
    },
    methods: {
      getVehiclesQRCode() {
        let data = {'id' :this.VehicleId, 'type':'vehicle', 'class':this.VehicleClass, 'vrm':this.VehicleVRM};
        var qrurl = this.QRCodeEndpoint + btoa(JSON.stringify(data));
        return qrurl;
      },
    },
  };
</script>
